import AddressSimple from "@/models/address/AddressSimple";
import IBlamable from "@/models/IBlamable";
import {AddressTitle, Salutation} from "@/helpers/constants";
import UserBlamable from "@/models/user/UserBlamable";

export default class Address extends AddressSimple implements IBlamable {

	public salutation!: Salutation | null;
	public title!: AddressTitle | null;
	public firstname!: string | null;
	public lastname!: string | null;
	public company!: string | null;
	public address1!: string | null;
	public address2!: string | null;
	public street!: string | null;
	public city!: string | null;
	public zip!: string | null;
	public county!: string | null;
	public state!: string | null;
	public countryCode!: string | null;

	public createdAt!: string | null;
	public createdBy!: UserBlamable | null;
	public updatedAt!: string | null;
	public updatedBy!: UserBlamable | null;

	public static fullName(address: Address | null): string | null {
		if (address === null) return null;

		const parts = [] as string[];
		if (address.firstname !== null && address.firstname.length > 0) parts.push(address.firstname);
		if (address.lastname !== null && address.lastname.length > 0) parts.push(address.lastname);
		return parts.length > 0 ? parts.join(' ') : null;
	}

}
